<!--
 * @Description: Jerry Create File
 * @Version: 1.0
 * @Autor: Jerry
 * @Date: 2021-12-02 09:36:33
 * @LastEditors: Jerry
 * @LastEditTime: 2021-12-02 16:39:44
-->

<template>
  <!-- 领取成功弹窗 -->
  <div>
    <el-dialog
      :visible.sync="dialogSucceed"
      width="355px"
      top="0"
      class="dialog-receive-successed"
      :show-close="false"
    >
      <img class="head-img" :src="require('../../../../assets/BrokerageCity/receive-succeed.png')" alt="">
      <div class="box-container">

        <div class="dialog-successed-box">
          <img class="receive-succeed-txt" :src="require('../../../../assets/BrokerageCity/receive-succeed-txt.png')" alt="">
          <div
            style="margin: 16px auto 40px; font-size: 16px; font-weight: 500; color: #111A34;"
          >{{ name }}</div>
          <el-button class="btn" @click="dialogSucceed=false"> 继续领券</el-button>
          <div class="view-coupons" @click="goPage('MyCoupon')">查看优惠券</div>
        </div>

      </div>
      <span> <img class="close-btn" :src="require('../../../../assets/BrokerageCity/close.png')" alt="" @click="dialogSucceed = false"> </span>

    </el-dialog>

  </div>
</template>
<script>
export default {
  name: 'ReceiveDialog',
  components: {},
  mixins: [],
  data() {
    return {
      dialogSucceed: false,
      checked: true,
      name: ''
    }
  },
  computed: {},
  watch: {},
  // 生命周期
  created() { },
  mounted() { },
  unmounted() { this.dialogSucceed = false },
  // 方法
  methods: {
    setStatus(val, name) {
      this.dialogSucceed = val
      this.name = name
    },
    goPage(name) {
      this.$router.push({
        name
      })
    }
  }
}
</script>
<style lang="less" scoped>
.dialog-receive-successed {
  // 领取成功弹窗
  /deep/ .el-dialog__header {
    padding: 0;
  }

  .box-container {
    margin-top: 52px;
  }

  .view-coupons {
    margin-top: 12px;

    &:hover {
      cursor: pointer;
    }
  }

  /deep/ .el-dialog {
    position: relative;
    top: 50%;
    margin: auto;
    margin: 0 auto;
    border-radius: 10px;
    width: 355px;
    background: linear-gradient(142deg, #F0F0FF 0%, #E7F1FF 100%);
    transform: translate(0, -50%);

    .head-img {
      position: absolute;
      top: -70px;
      left: 0;
      width: 100%;
      height: 126px;
    }

    .close-btn {
      position: absolute;
      right: 0;
      bottom: -40px;
      left: 0;
      margin: auto;
      width: 100%;
      width: 27.5px;
      height: 27.5px;

      &:hover {
        cursor: pointer;
      }
    }

    .receive-succeed-txt {
      width: 140px;
      height: 32px;
    }

    .btn {
      border-radius: 28px;
      width: 173px;
      height: 55px;
      color: #FFFFFF;
      background: linear-gradient(180deg, #3A90FF 0%, #0F6EEA 100%);
      // border-image: linear-gradient(180deg, rgba(0, 85, 197, 1), rgba(151, 196, 255, 1)) 2 2;
    }
  }
}

</style>
